import React from 'react'
import "./social.css"

const Social = () => {


    window.addEventListener("scroll", function () {
        const scrollup = document.querySelector(".social");
        if (this.scrollY >= 300) {
            scrollup.classList.add("show-social");
        } 
        else {
            scrollup.classList.remove("show-social")
        } 
    })




  return (
    <div className="social">
        <div className='social__icons'>
        <a href="#header" className="social-icon" >
            <i className="uil uil-estate"></i>
        </a>

        <a href="#services" className="social-icon" >
            <i className="uil uil-briefcase-alt"></i>
        </a>

        <a href="#business" className="social-icon" >
            <i className="uil uil-user"></i>
        </a>


        <a href="https://www.instagram.com/emanuelpropainting/" className="social-icon" target="_blanck">
            <i class="uil  uil-instagram"></i>
        </a>
        
        <a href="https://www.facebook.com/profile.php?id=61558828893985" className="social-icon" target="_blanck">
            <i class="uil  uil-facebook"></i>
        </a>

        <a href="#contact" className="social-icon" >
            <i className="uil uil-message"></i>
        </a>
        </div>
        <div className='scrollup__2'>
        <a href="#" className="social__icon">
            <i className="uil uil-arrow-up scrollup__icon"></i>
        </a>
        </div>
    </div>
  )
}

export default Social
